import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import authSlice from './reducers/authSlice';
import masterDataSlice from './reducers/masterDataSlice';
import  getCloudBucketSlice  from './reducers/getCloudBucketSlice';
import  commonSlice  from './reducers/commonSlice';
import  commonSliceWhiteList  from './reducers/commonSliceWhiteList';

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["commonData"]
};

const reducer = combineReducers({
  authentication: authSlice,
  masterData: masterDataSlice,
  getCloudBucketDetails: getCloudBucketSlice,
  commonData: commonSlice,
  commonDataWhiteList: commonSliceWhiteList
});

const persistedReducer = persistReducer(persistConfig, reducer);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});